import { render } from "./SliderMain.vue?vue&type=template&id=0a62e290"
import script from "./SliderMain.vue?vue&type=script&lang=js"
export * from "./SliderMain.vue?vue&type=script&lang=js"

import "./SliderMain.vue?vue&type=style&index=0&id=0a62e290&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__